import { render, staticRenderFns } from "./SelecionarArquivoVetorial.vue?vue&type=template&id=11a0dae6&scoped=true&lang=pug"
import script from "./SelecionarArquivoVetorial.vue?vue&type=script&lang=js"
export * from "./SelecionarArquivoVetorial.vue?vue&type=script&lang=js"
import style0 from "./SelecionarArquivoVetorial.vue?vue&type=style&index=0&id=11a0dae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a0dae6",
  null
  
)

export default component.exports